import React from 'react'
import Menu from './menu'

const LanguageMenu = props => <Menu {...props} />

export default LanguageMenu
